import React from "react";
import { MODEL } from "../../model";

const Features = () => {
  return (
    <section className="features">
      {MODEL.data.features.map((item, index) => {
        return (
          <div className="single__feature" key={index}>
            <h3 className="mb-3">
              <i className={item.icon}></i>
            </h3>
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        );
      })}
    </section>
  );
};

export default Features;
